<template>
  <article class="classes">
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">Crear oferta</p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'offer'})"
                  class="breadcums__option"
                >
                  Ofertas creadas
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  Nueva oferta
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-1">
              <button
                class="faccess_button px-5"
                @click="createOffer()"
              >
                Crear
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__info">
        <v-layout row wrap>
        <v-flex xs6>
          <!-- Fotos de la oferta -->
          <span class="table_card__info--label">Imagen</span>
          <div class="trainers__form--photo_container">
            <label
              for="trainerPhoto"
              style="height: 60px; vertical-align: middle"
              class="faccess_button buttom_shadow px-5"
            >Examinar</label>
            <input
              id="trainerPhoto"
              type="file"
              @change="onFileChange"
              name="logo"
              multiple>
            <p v-if="!url_change">{{ photo_name }}</p>
          </div>
          <v-flex
            xs12
            v-if="url_change"
            class="classes__image_container">
            <div
              v-for="(image, index) in urls"
              class="classes__image_container--image"
              :style="{backgroundImage: 'url('+ image +')'}"
              :key="index"
            >
              <div
                class="table_card__info--remove"
                @click="removeImage(index)">
                <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/cross.svg" alt="">
              </div>
            </div>
          </v-flex>
          <v-flex xs12>
            <span class="table_card__info--label">Título</span>
            <input
              class="faccess_input"
              type="text"
              name="Title"
              placeholder="Título de la oferta"
              v-model="offer.attributes.title"
            >
          </v-flex>
          <v-flex xs12>
            <span class="table_card__info--label">Descripción</span>
            <textarea
              class="faccess_textarea"
              placeholder="Descripción"
              v-model="offer.attributes.description"
            >
            </textarea>
          </v-flex>
          <v-flex xs12>
            <span class="table_card__info--label">Términos y condiciones</span>
            <textarea
              class="faccess_textarea"
              name="TyC"
              placeholder="Términos y condiciones generales de la clase"
              v-model="offer.attributes.tc"
            >
            </textarea>
          </v-flex>
          <v-flex xs12>
            <span class="table_card__info--label">Link</span>
            <input
              class="faccess_input"
              type="text"
              name="link"
              placeholder="Link de redención de la oferta"
              v-model="offer.attributes.link"
            >
          </v-flex>
          <v-flex xs12>
            <span class="table_card__info--label">Fecha de vencimiento</span>
            <app-single-date-picker :solid="false" @filterQuery="changeDate($event)"></app-single-date-picker>
          </v-flex>
          <v-flex xs12>
            <span class="table_card__info--label">Categoría</span>
            <div
              class="faccess_select with_box_shadow"
              style="width: 100%; margin-bottom: 20px;padding: 0">
              <select
                class=""
                style="width: 100%; height: 100%; outline: none; padding: 0 10px;"
                v-model="parent_category">
                <option
                  selected="selected"
                  disabled>Selecciona</option>
                <option
                  v-for="(category, index) in getCategories()"
                  :value="category"
                  :key="index"
                >
                  {{category.attributes.name}}
                </option>
              </select>
              <img src="@/assets/img/arrow-down-solid.svg">
            </div>
          </v-flex>
          <v-flex xs12>
            <span class="table_card__info--label">Locaciones</span>
            <div
              class="faccess_select"
              style="width: 100%; margin-bottom: 20px;"
              @click="show_trainers_modal = true"
            >
              <p >{{trainers_text}}</p>
              <img src="@/assets/img/arrow-down-solid.svg">
            </div>
          </v-flex>

          <v-flex xs12 class="mt-5">
            <v-switch
              class="data_card__switch"
              :label="`Oferta visible para los usuarios`"
              color="#1476fb"
              v-model="offer.attributes.published"
            ></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-switch
              class="data_card__switch"
              color="#1476fb"
              :label="`Se reclama con código QR`"
              v-model="offer.attributes.has_code"
              @change="offer.attributes.has_code?multicodes=true:'';emptyCodes();"
            ></v-switch>
          </v-flex>
          <v-flex xs12 class="mb-4">
            <v-switch
              class="data_card__switch"
              :label="`Múltiples códigos de canje`"
              color="#1476fb"
              v-model="multicodes"
              @change="emptyCodes();"
              :disabled="offer.attributes.has_code"
            ></v-switch>
          </v-flex>
          <v-flex v-if="!multicodes" xs12>
            <span class="table_card__info--label">Código promocional único</span>
            <input
              class="faccess_input"
              type="text"
              name="Name"
              placeholder="Código promocional"
              :maxlength="20"
              @keypress="checkCharacters"
              v-model="offer.attributes.reedem_code" >
            <v-flex class="mt-3" v-if="offer.attributes.reedem_code!=null && offer.attributes.reedem_code.length>0 " >
              <span class="table_card__info--label">Límite de canjes de la oferta</span>
              <div class="table_card__counter">
                <div class="faccess_counter">
                  <button
                    class="faccess_counter__button"
                    @click="removeFromRedemption('redeem_limit')"
                  >
                    <img src="@/assets/img/icons/icono-menos.svg">
                  </button>

                  <span v-if="numberStaticCodes<0">{{numberStaticCodes < 0 ? 'Sin limite': numberStaticCodes}}</span>
                  <input v-else
                    class="faccess_counter__input"
                    type="text" @keypress="checkCharacters"
                    name="Name" :min="1" :maxlength="50"
                    placeholder="Número de canjes para la oferta"
                    v-model="numberStaticCodes"
                  >
                  <button
                    class="faccess_counter__button"
                    @click="addToRedemption('redeem_limit')"
                  >
                    <img src="@/assets/img/icons/icono-mas.svg">
                  </button>
                </div>
              </div>
            </v-flex>
          </v-flex>
          <v-flex v-else class="my-4 mb-5">
            <span v-if="offer.attributes.has_code" class="table_card__info--label">Códigos promocionales para QR (Formato Excel)</span>
            <span v-else class="table_card__info--label">Códigos promocionales (Formato Excel)</span>
            <div class="trainers__form--photo_container">

              <label
                for="excel_input"
                class="faccess_button buttom_shadow px-5">Examinar</label>
              <input
                id="excel_input"
                type="file"
                ref="excel_input"
                @change="excelUpload"
                name="excel">
            </div>
            <div v-if="codes.length!=0">
              <p class="table_card__info--label">Nombre del archivo: </p>
              <p style="font-size: 10px;" ><img style="width:26px" src="https://karrottsportlife.s3-us-west-2.amazonaws.com/excel.png"/>{{excelTitle}}</p>
              <p class="table_card__info--label">No. códigos importados: </p>
              <p style="margin-left:27px;font-size: 12px;">{{codes.length }}</p>
            </div>
          </v-flex>
          <v-flex xs12 class="mt-4">
            <v-switch
              class="data_card__switch"
              :label="`Permitir varios canjes por usuario`"
              color="#1476fb"
              v-model="multi_redeemable_per_user"
            ></v-switch>
            </v-flex>
          <v-flex xs12 v-if="offer.attributes.is_multi_redeemable_per_user">
            <span class="data_card__info--label">Límite de canjes por usuario</span>
            <div class="data_card__counter justified">
              <div class="justified__container">
                <button
                  class="faccess_counter__button"
                  @click="removeFromRedemption('redeem_limit_per_user')"><img src="@/assets/img/icons/icono-menos.svg" /></button>
                  <input
                      class="faccess_counter__input"
                      type="text"
                      name="Name"
                      :value="offer.attributes.redeem_limit_per_user"
                      readonly
                      @change="excelTitle = ''"
                    />
                <button
                  class="faccess_counter__button"
                  @click="addToRedemption('redeem_limit_per_user')"><img src="@/assets/img/icons/icono-mas.svg" /></button>
              </div>
            </div>
          </v-flex>
          <v-flex xs12 class="mt-4">
            <v-switch
              class="data_card__switch mt-4 mb-4"
              color="#1476fb"
              :label="`Oferta obtenida por un reward`"
              v-model="offer.attributes.is_rewardable"
            ></v-switch>
          </v-flex>
          <div class=""
            v-if="offer.attributes.is_rewardable">
            <v-flex xs12>
              <span class="table_card__info--label">Segmento</span>
              <div
                class="faccess_select with_box_shadow"
                style="width: 100%; margin-bottom: 20px;padding: 0">
                <select
                  class=""
                  style="width: 100%; height: 100%; outline: none; padding: 0 10px;"
                  v-model="condition_selected"
                  placeholder="Selecciona"
                  @change="offer.reward_attributes.condition_id = condition_selected.id">
                  <option
                    selected
                    disabled="disabled">Selecciona</option>
                  <option
                    v-for="(condition, index) in conditions"
                    :value="condition"
                    :key="index"
                  >
                    {{condition.attributes.description}}
                  </option>
                </select>
                <img src="@/assets/img/arrow-down-solid.svg">
              </div>
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Fecha de activación del reward</span>
              <app-single-date-picker :solid="false" @filterQuery="changeRewardDate($event, 'from')"></app-single-date-picker>
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Fecha de vencimiento del reward</span>
              <app-single-date-picker :solid="false" @filterQuery="changeRewardDate($event, 'until')"></app-single-date-picker>
            </v-flex>
          </div>
        </v-flex>


        <!-- Custom component offer -->
         <v-flex xs6 class="preview_item">
           <preview-offer
            :offer="offer"
            :url_change="url_change"
            :urls="urls"
            :locations_selected="locations_selected"
           ></preview-offer>
         </v-flex>


      </v-layout>
      </div>
      <div class="table_card__footer py-4">
        <button
          class="faccess_button px-5 mr-1"
          @click="createOffer()"
        >
          Crear
        </button>
      </div>
    </div>

    <trainers-modal
      v-if="show_trainers_modal"
      :trainers="locations"
      :selected="locations_selected"
      :title = "'Selecciona las locaciones'"
      @closeTrainersModal="closeTrainersModal($event)"
      @saveTrainers="filterSelectedTrainers($event)">
    </trainers-modal>
  </article>

</template>

<script>

import previewOffer from '../../shared/PreviewOffer.vue'

export default {
  data(){
    return{
      urls: [],
      images: [],
      codes:[],
      excelTitle:"",
      multicodes:false,
      numberStaticCodes: 1,
      locations:this.getLocations(),
      tags_selected: [],
      parent_category:'Selecciona',
      conditions: [],
      condition_selected: 'Selecciona',
      is_valid: false,
      locations_selected: [],
      url_change: false,
      photo_name: "No se han seleccionado archivos",
      trainers_text: 'Selecciona',
      show_trainers_modal: false,
      selected_trainers: [],
      multi_redeemable_per_user: false,
      offer:{
        attributes:{
          title: '',
          description: '',
          offer_photos_attributes: [],
          tc: '',
          link: '',
          expiration: '',
          is_rewardable: false,
          is_multi_redeemable_per_user: false,
          redeem_limit_per_user: null,
          redeem_limit: 0,
          redeem_count: 0,
          published: false,
          has_code: false,
          reedem_code: null,
          company_id:this.getCompany().id
        },
        reward_attributes:{
          condition_id: null,
          from: '',
          until:''
        },
        company:{
          id:this.getCompany().id
        },
        offer_photos_attributes: [],
        location_offers_attributes: [] // offer_id: ''

      }
    }
  },
  components: {
    previewOffer: previewOffer
  },
  mounted(){
    this.updateTags([])
    this.findCategories()
    this.findTags()
    this.findLocations()
    this.locations=this.getLocations()
    console.info(this.locations_selected)
    console.info(this.getLocations())
    try {
      const data={company:{id:this.getCompany().id}}
      this.$http.post('conditions/company',{data:this.encrypt(data).toString()},)
      .then(function(response){
        this.conditions = response.body.data
        console.log('Segmento: ', this.conditions)
      }, function(response){
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
    } catch (e) {
      alert(e.message)
    }
    // cl tags_selected
  },
  watch:{
    urls(){
      this.url_change = true;
    },
    multi_redeemable_per_user(){
      this.offer.attributes.is_multi_redeemable_per_user = this.multi_redeemable_per_user
      if(this.multi_redeemable_per_user == true){
        this.offer.attributes.redeem_limit_per_user = 1
      }else {
        this.offer.attributes.redeem_limit_per_user = null
      }
    },
    numberStaticCodes(){      
      if (this.offer.attributes.redeem_limit < this.offer.attributes.redeem_limit_per_user){
        this.offer.attributes.redeem_limit_per_user = this.offer.attributes.redeem_limit
      }
    },
    parent_category(){
      // cl parent_category
    }

  },
  methods:{
    isNumber(event){
      var keycode= event.keyCode
      var ans=true;
      if(keycode<48 || keycode>57){
        event.preventDefault();
        ans=false;
      }
      return ans;
    },
    closeTrainersModal(val){
      this.show_trainers_modal = val
    },
    emptyCodes(){
      if(this.multicodes){
        this.offer.attributes.redeem_limit=0;
        this.offer.attributes.reedem_code=null;
      }else{
        this.codes=[];
        this.excelTitle="";
      }
    },
    filterSelectedTrainers(val){
      this.locations_selected = val
      this.trainers_text = val.length > 1 ? `${val.length} seleccionados` : `${val.length} seleccionado`
      this.show_trainers_modal = false;
    },
    asdf(){
      console.info(this.locations_selected)
      console.info(this.getLocations())
    },
    deleteImage(index){
      this.urls.splice(index, 1)
      this.offer.offer_photos_attributes.splice(index,1)
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var fileUpload = document.getElementById("trainerPhoto");
      //Validate whether File is valid Excel file.
      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpeg|.jpg|.png)$/;
      if (regex.test(fileUpload.value.toLowerCase())) {
        for (var i = 0; i < files.length; i++) {
          this.urls.push(URL.createObjectURL(files[i]));
          // this.images.push(files[i])
          this.createImage(files[i])
        }
      } else {
          // alert("Por favor subir un archivo de imagen estándard (Formatos png, jpg, etc).");
          this.updateAlertMessage("Por favor subir un archivo de imagen estándard (Formatos png, jpg, etc).");
          this.updateIsInAlert(true);
      }

    },
    createImage (file) {

      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.offer.offer_photos_attributes.push({image: reader.result})
      }

    },
    excelUpload(){
      var fileUpload = document.getElementById("excel_input");
      //Validate whether File is valid Excel file.
      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx|.ods|.xlsm|.xsv|.txt)$/;
      if (regex.test(fileUpload.value.toLowerCase())) {
          var vm=this;

          if (typeof (FileReader) != "undefined") {
              var reader = new FileReader();
              vm.excelTitle=fileUpload.files[0].name;
              //For Browsers other than IE.
              if (reader.readAsBinaryString) {
                  reader.onload = function (e) {
                      vm.ProcessExcel(e.target.result);
                  };
                  reader.readAsBinaryString(fileUpload.files[0]);
              } else {
                  //For IE Browser.
                  reader.onload = function (e) {
                      var data = "";
                      var bytes = new Uint8Array(e.target.result);
                      for (var i = 0; i < bytes.byteLength; i++) {
                          data += String.fromCharCode(bytes[i]);
                      }
                      vm.ProcessExcel(data);
                  };
                  reader.readAsArrayBuffer(fileUpload.files[0]);
              }
          } else {
              // alert("This browser does not support HTML5.");
              vm.updateAlertMessage("This browser does not support HTML5.");
              vm.updateIsInAlert(true);
          }
      } else {
          // alert("Por favor subir un archivo de códigos válido (Formato Excel).");
          vm.updateAlertMessage("Por favor subir un archivo de códigos válido (Formato Excel).");
          vm.updateIsInAlert(true);
      }
    },
    ProcessExcel(data) {
      //Read the Excel File data.
        var workbook = XLSX.read(data, {
            type: 'binary'
        });

      //Fetch the name of First Sheet.
        var firstSheet = workbook.SheetNames[0];

        //Read all rows from First Sheet into an JSON array.
        var excelRows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet],{header:["data"]});
        var codes=[]
        for(var row in excelRows){
          codes.push(excelRows[row]["data"]);
        }
        this.codes=codes;
        this.offer.attributes.redeem_limit=this.codes.length;
        //cl codes
    },

    changeDate(val){
      this.offer.attributes.expiration = val
    },
    changeRewardDate(val, context){
      this.offer.reward_attributes[context] = val
      // cl context
      // cl offer.reward_attributes[context]
    },
    addToRedemption(object) {
      if (object == "redeem_limit") {
        this.numberStaticCodes = Number(this.numberStaticCodes) + 1;
        this.offer.attributes[object] = this.numberStaticCodes;
      }else if(object == "redeem_limit_per_user"){
        if (this.offer.attributes.redeem_limit_per_user < this.numberStaticCodes){
          this.offer.attributes[object] = Number(this.offer.attributes[object]) + 1;
        }
      }
    },
    removeFromRedemption(object) {
      if (object == "redeem_limit") {
        if (
          Number(this.numberStaticCodes) >
            Number(this.offer.attributes.redeem_count) &&
          Number(this.numberStaticCodes) > 1
        ) {
          this.numberStaticCodes = Number(this.numberStaticCodes) - 1;
          this.offer.attributes[object] = Number(this.numberStaticCodes);
        }
      }else if(object == "redeem_limit_per_user"){
        if(this.offer.attributes[object] > 1){
          this.offer.attributes[object] = Number(this.offer.attributes[object]) - 1;
        }
      }      
      // if(Number(this.offer.attributes[object]) >= 0){
      //   //Esta linea es cuando se puedan los códigos infinitos
      //   //this.offer.attributes[object] = Number(this.offer.attributes[object]) - 1
      //   this.offer.attributes[object]=0;
      // }
    },
    removeImage(index){
      this.$delete(this.urls, index)
    },
    // deleteImage(index){
    //   // if(this.urls[index].id != undefined && this.urls[index].id != null){
    //   //   this.urls[index]._destroy = this.this.urls[index].id
    //   //   this.offer.offer_photos_attributes.push({id: this.urls[index].id, _destroy: this.urls[index]._destroy})
    //   // }
    //   this.$delete(this.urls, index);
    //   this.$delete(this.offer.offer_photos_attributes, index);
    //   // this.urls.splice(index, 1)
    //   // this.offer.offer_photos_attributes.splice(index, 1)
    //   // this.current_image_url = this.urls[0].id ? this.getImageServer() + this.urls[0].image : this.urls[0].url_image
    // },
    createOffer(){      
      if(this.offer.attributes.is_rewardable){
        if(this.offer.reward_attributes.condition_id != null &&
           this.offer.reward_attributes.from != '' &&
           this.offer.reward_attributes.until != ''){
          this.is_valid = true
        }else{
          this.is_valid = false
        }
      }else{
        this.$delete(this.offer, 'reward_attributes')
        this.is_valid = true
      }
      for (var i = 0; i < this.locations_selected.length; i++) {
        this.offer.location_offers_attributes.push({location_id: this.locations_selected[i].id})
      }
      if (this.is_valid) {
        if(this.offer.offer_photos_attributes.length>0){
          if(this.offer.attributes.title.length>0 && this.offer.attributes.description.length>0
          && this.offer.attributes.tc.length>0 && this.offer.attributes.expiration.length>0 ){
            if(this.codes.length>0|| (!this.multicodes && this.offer.attributes.reedem_code && this.offer.attributes.reedem_code.length>0)){
              if(this.locations_selected.length>0){
                if (this.parent_category != null && this.parent_category != "Selecciona") {
                  // cl parent_category
                  this.offer.attributes.object_categories_attributes = []
                  var category = {category_id: this.parent_category.id, categorizable_type: 'Offer'}
                  this.offer.attributes.object_categories_attributes.push(category);
                  // this.offer.attributes.category_ids = [this.parent_category.id]


                  if (this.tags_selected.length > 0) {
                    // cl tags_selected
                    this.offer.attributes.object_tags_attributes = []
                    for (var i = 0; i < this.tags_selected.length; i++) {
                        var tag = { tag_id: this.tags_selected[i].id,
                                    taggable_type: 'Offer'
                                  }
                      this.offer.attributes.object_tags_attributes.push(tag)
                    }
                  }

                  try {
                    this.offer.attributes.redeem_limit = this.numberStaticCodes;
                    if(this.offer.attributes.reedem_code!=null && this.offer.attributes.reedem_code.length>0 &&
                      this.offer.attributes.redeem_limit>=0 ){
                          var myCodes=[];
                          for( let i=0; i<this.offer.attributes.redeem_limit; i++){
                            myCodes.push(this.offer.attributes.reedem_code);
                          }
                          this.codes=myCodes;
                    }
                    else if(this.offer.attributes.reedem_code!=null){
                      this.codes=[];
                      this.offer.attributes.redeem_limit=-1;
                    }
                    if(!this.multicodes && this.offer.attributes.reedem_code && this.offer.attributes.reedem_code.length>0
                        && this.offer.attributes.redeem_limit==-1){
                          this.codes=[this.offer.attributes.reedem_code.toString() + "&INFTFFER&"]
                    }

                    this.offer["codes"]=this.codes;
                    this.offer.attributes.has_code=!this.offer.attributes.has_code;                    
                    var offerJson =this.offer;
                    
                    this.$http.post('offers',{
                      data: this.encrypt(offerJson).toString()
                    },{
                      headers: {
                        "X-Device-ID" : this.getDeviceId(),
                        "Authorization" : 'Bearer ' + this.getUserToken()
                      }
                    }).then(function(response){
                      if(this.offer.attributes.is_rewardable){
                        this.$router.push({ name: "reward" });
                      } else {
                        this.$router.push({ name: "offer" });
                      }
                      if(response.body.meta != undefined && response.body.meta != null){
                        if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                          this.checkToken(response.body.meta.authentication_token)
                        }
                      }
                    }, function(response){
                      if(response.body.meta != undefined && response.body.meta != null){
                        if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                          this.checkToken(response.body.meta.authentication_token)
                        }
                      }
                    })
                  } catch (e) {
                    alert(e.message)
                  }
                }else {
                  alert('Cada oferta debe tener mínimo una categoría ');
                }
              }else {
                alert('Cada oferta debe tener mínimo una locación');
              }
            }else {
              alert('Debes escribir o adjuntar algún código promocional');
            }
          }else {
            alert('Debes completar todos los campos antes de enviar la oferta');
          }
        } else {
          alert('Debes adjuntar al menos una imagen para la oferta');
        }
      } else {
        alert('Debes asociar un segmento con las fechas completas para esta oferta recompensable');
      }
    },
    checkCharacters($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (!((keyCode > 64 && keyCode < 91) || (keyCode > 96 && keyCode < 123) || keyCode == 8 || (keyCode >= 48 && keyCode <= 57))) {
        $event.preventDefault(); 
      }
    }
  },
  computed: {
    redemtions_limit() {
      var sum = 0;
      sum = -this.offer.attributes.redeem_count;
      if (
        this.offer.attributes.reedem_code == undefined ||
        this.offer.attributes.reedem_code == null
      ) {
        if (this.offer.attributes.redeem_limit >= 0) {
          for (var element in this.excelFiles) {
            sum += Number(this.excelFiles[element]);
          }
          if (this.codes.length > 0) {
            sum += this.codes.length;
          } else if (this.numberStaticCodes > 0) {
            sum += Number(this.numberStaticCodes);
          }
          this.offer.attributes.redeem_limit = sum;
        } else {
          sum = -1;
        }
      } else {
        sum = this.numberStaticCodes;
      }      
      return sum;      
    },
  },
}
</script>

<style lang="css">
p{
  margin-bottom: 0;
}

.text_title{
  font-weight: bold;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/offers/New_offer.vue